import { render, staticRenderFns } from "./UserKycCard.vue?vue&type=template&id=866bd730&"
import script from "./UserKycCard.vue?vue&type=script&lang=js&"
export * from "./UserKycCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports